export default __webpack_public_path__ + "static/media/logo-guider-admin-white.b41e1ea6.svg";